/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Breadcrumb } from 'matx';
import { useDispatch } from 'react-redux';

import UsersTable from './shared/UsersTable';
import { getUsersList } from 'app/redux/actions/UserActions';
import { Button, Icon } from '@material-ui/core';
import { Link } from 'react-router-dom';

const Users = () => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(getUsersList());
  }, []);

  return (
    <div className="m-sm-30 menu">
      <div className="mb-sm-30 flex items-center justify-between">
        <Breadcrumb
          routeSegments={[
            { name: 'Users', path: '/users/list' },
            { name: 'List' }
          ]}
        />
        
        <div className="">
          <Button
            component={Link}
            to="/users/add"
            variant="contained"
            color="primary"
            endIcon={<Icon>add</Icon>}
          >
            Add New
          </Button>
        </div>
      </div>
      <UsersTable />
    </div>
  );
};

export default Users;
